/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';
import { PlusIconOutline } from '@neo4j-ndl/react/icons';

const options = [
  { label: 'Movie recommendations', value: 'movie-recommendations' },
  { label: 'Fraud detection', value: 'fraud-detection' },
  { label: 'Supply chain', value: 'supply-chain' },
  { label: 'Customer 360', value: 'customer-360' },
  { label: 'Knowledge graph', value: 'knowledge-graph' },
  { label: 'Network topology', value: 'network-topology' },
  { label: 'Identity resolution', value: 'identity-resolution' },
  { label: 'Master data management', value: 'master-data-management' },
  { label: 'Social network analysis', value: 'social-network-analysis' },
  { label: 'Route optimization', value: 'route-optimization' },
  { label: 'Recommendation engine', value: 'recommendation-engine' },
  { label: 'Access control', value: 'access-control' },
  { label: 'Data lineage', value: 'data-lineage' },
  { label: 'Entity resolution', value: 'entity-resolution' },
  { label: 'Bill of materials', value: 'bill-of-materials' },
  { label: 'Impact analysis', value: 'impact-analysis' },
  { label: 'Anti money laundering', value: 'anti-money-laundering' },
  { label: 'Dependency mapping', value: 'dependency-mapping' },
  { label: 'Patient journey', value: 'patient-journey' },
  { label: 'Content personalization', value: 'content-personalization' },
  { label: 'Risk assessment', value: 'risk-assessment' },
  { label: 'Churn prediction', value: 'churn-prediction' },
  { label: 'Inventory tracking', value: 'inventory-tracking' },
  { label: 'Semantic search', value: 'semantic-search' },
  { label: 'Digital twin', value: 'digital-twin' },
];

const Component = () => {
  return (
    <div className="n-flex n-flex-col n-gap-token-4">
      <Combobox
        label="Project"
        placeholder="Select project"
        searchPlaceholder="Search projects"
        options={options}
        // An action never becomes part of the value. It runs, the panel closes,
        // and the selection is left as it was, which is what makes it usable for
        // leaving the combobox entirely.
        actions={[
          {
            label: 'All projects',
            onSelect: () => console.info('all projects'),
          },
          {
            // A divider above the action separates it from the actions before
            // it. The first action never needs one: it already sits below the
            // divider that separates actions from options.
            hasDivider: true,
            label: 'Create project',
            leadingVisual: <PlusIconOutline />,
            // The search value comes along, so an unmatched query can prefill
            // the flow the action leads to.
            onSelect: ({ searchValue }) =>
              console.info('create project with search value', searchValue),
          },
        ]}
        helpText="actions stay pinned below the scrolling options, and are exempt from searching"
      />
    </div>
  );
};

export default Component;
